import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { MenuItem } from "primeng/api";
import { CardModule } from "primeng/card";
import { StepsModule } from "primeng/steps";
import { Observable, Subscription } from "rxjs";
import { DataExportService } from "../data-export.service";

@Component({
	selector: "partikelart-limitfinder-steps-page",
	templateUrl: "./multi-export-steps-page.component.html",
	styleUrls: ["./multi-export-steps-page.component.scss"],
	standalone: true,
	imports: [CommonModule, RouterModule, CardModule, StepsModule, TranslatePipe],
})
export class MultiExportStepsPageComponent implements OnInit, OnDestroy {
	private translateSub: Subscription | undefined;
	items: MenuItem[] = [];
	step = 0;
	currentStep$: Observable<number>; // Adjust the type accordingly
	constructor(
		private exportService: DataExportService,
		private translate: TranslateService,
	) {
		this.currentStep$ = this.exportService.currentStep$;
	}

	ngOnInit() {
		this.items = [{ label: "Bauteilauswahl" }, { label: "Datenauswahl" }];
		this.translate.get(["export.partSelection", "export.dataSelection"]).subscribe((values) => {
			this.items[0].label = values["export.partSelection"];
			this.items[1].label = values["export.dataSelection"];
		});
	}
	ngOnDestroy() {
		this.translateSub?.unsubscribe();
	}
}
